import { education, experience } from "../data/portfolio";

export default function Experience() {
  return (
    <section className="section experience" aria-labelledby="experience-title">
      <div className="section__inner">
        <header className="section-heading section-heading--compact" data-reveal>
          <p className="section-kicker">02 / Background</p>
          <h2 id="experience-title">Experience</h2>
        </header>

        <div className="timeline">
          {experience.map((item, index) => (
            <article
              className="timeline-row"
              data-reveal
              style={{ "--reveal-delay": `${index * 70}ms` }}
              key={item.company}
            >
              <div className="timeline-row__marker" aria-hidden="true">
                <span />
              </div>
              <h3>{item.company}</h3>
              <p className="timeline-row__role">{item.role}</p>
              <p className="timeline-row__period">{item.period}</p>
              <p className="timeline-row__details">{item.details}</p>
            </article>
          ))}
        </div>

        <div className="education" data-reveal>
          <h3 className="section-kicker">Education</h3>
          <div className="education__items">
            {education.map((item) => (
              <p key={item}>{item}</p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
